import {Pipe, PipeTransform} from "@angular/core";
import {Utils} from "../utils/utils";

@Pipe({
  name: 'replaceTextWithBracers',
  standalone: true
})

export class DbReplaceTextPipe implements PipeTransform {

  transform(text: string, textWithBracers: any = null): string | null {
    return Utils.replaceTextInBracers(text, textWithBracers);
  }

}
